module.exports = __webpack_public_path__ + "img/trunk_10x1.6aa69c26.svg";